import { ColorScheme } from '../color.interface';

/**
 * Excel color scheme.
 */
export const COLOR_SCHEME_EXCEL: ColorScheme = [];
